import { render, staticRenderFns } from "./Lgx02828116183172530569271.vue?vue&type=template&id=0438c144&"
import script from "./Lgx02828116183172530569271.vue?vue&type=script&lang=js&"
export * from "./Lgx02828116183172530569271.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02828116183172530569271.vue?vue&type=style&index=0&id=0438c144&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports